import { useControlledValue } from 'ahooks';
import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React, { FC } from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { prop } from 'styled-tools';
import { Button } from 'components/atoms/button';

const ColorPreview = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${prop('color')};
  margin-right: var(--spacing-03);
  border: 1px solid var(--border-color);
`;

const StyledSketchPicker = styled(SketchPicker)`
  box-shadow: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  border: none !important;
  background: none !important;
  width: 240px !important;
`;

export const ColorPicker: FC<{
  value?: string;
  onChange?: (color: string | undefined) => void;
  hideColorCode?: boolean;
  placement?: TooltipPlacement;
}> = (props) => {
  const { onChange, hideColorCode = false, placement = 'right' } = props;
  const [state, setState] = useControlledValue<string>(props);
  const handleChangeComplete = (_color: ColorResult) => {
    setState(_color.hex);
  };

  const handleVisibleChange = (visible: boolean) => {
    if (!visible) {
      if (onChange) {
        onChange(state);
      }
    }
  };

  return (
    <Popover
      onVisibleChange={handleVisibleChange}
      content={
        <StyledSketchPicker
          color={state}
          onChangeComplete={handleChangeComplete}
        />
      }
      placement={placement}
      trigger="click"
    >
      <Button icon={<ColorPreview color={state} />} type="link">
        {!hideColorCode && (state || <FormattedMessage id="choose" />)}
      </Button>
    </Popover>
  );
};
